import { render, staticRenderFns } from "./TmsStudents.vue?vue&type=template&id=7cb8fa77&scoped=true&"
import script from "./TmsStudents.vue?vue&type=script&lang=js&"
export * from "./TmsStudents.vue?vue&type=script&lang=js&"
import style0 from "./TmsStudents.vue?vue&type=style&index=0&id=7cb8fa77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb8fa77",
  null
  
)

export default component.exports